import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { CoreService } from '../core/core.service';
import { CredentialsService } from '../core/credentials.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
})

export class LoginComponent {

  title: string;
  auth: Auth;
  authenticating: boolean;
  loginError: string;
  email: string;
  password: string;

  constructor(private api: AuthService, private router: Router, private mainService: Main, private credentialsService: CredentialsService, private coreService: CoreService, @Inject(Restangular) public Restangular) {
    this.title = this.api.title;
    this.auth = {
      client_id: '9512b842-df0d-43ba-bb0b-a75e3bdbf8b7',
      client_secret: 'wsDy6GtntG2B7AqpHbz5p7VRLuUDwuEvpo1DOpCM',
      grant_type: 'password',
      username: '',
      password: ''
    };
    this.loginError = '';
    this.authenticating = false;
  }

  login() {
    debugger;
    this.authenticating = true;
    this.loginError = '';
    this.api.authenticate(this.auth).subscribe((res: any) => {
      debugger;
      this.authenticating = false;
      this.loginError = '';
      console.log(res);
      if (res.user.data.type === 'super_admin' || res.user.data.type === 'system_admin') {
        localStorage.setItem('access_token', res.auth.access_token);
        localStorage.setItem('refresh_token', res.auth.refresh_token);
        this.Restangular.setDefaultHeaders({ Authorization: 'Bearer ' + localStorage.getItem('access_token') });
        this.credentialsService.setCredentials(res.user.data, true);
        localStorage.setItem('init', JSON.stringify(true));
        this.router.navigate(['']);
        this.mainService.toast({ title: 'Success', body: 'Welcome!', type: 'dark' });
      }
      else {
        localStorage.clear();
        this.mainService.toast({ title: 'Forbidden', body: 'Access denied!', type: 'danger' });
      }
      this.router.navigate(['']);
    }, (err) => {
      debugger;
      this.authenticating = false;
      this.mainService.toast({ title: 'Unauthorized', body: err.data.message, type: 'danger' });
    });

  }


  getLoggedinUser() {
    debugger;
    this.api.getLoggedInUser().subscribe((res: any) => {
      debugger;
      if (res.data.type === 'super_admin' || res.data.type === 'system_admin') {
        //localStorage.setItem('user', JSON.stringify(res.data));
        this.credentialsService.setCredentials(res.data, true);
        localStorage.setItem('init', JSON.stringify(true));
        //localStorage.setItem('user', res.data);
        this.router.navigate(['']);
        this.mainService.toast({ title: 'Success', body: 'Welcome!', type: 'dark' });
      }
      else {
        localStorage.clear();
        this.mainService.toast({ title: 'Forbidden', body: 'Access denied!', type: 'danger' });
      }
      this.router.navigate(['']);

    });
  }
}

interface Auth {
  client_id: string;
  client_secret: string;
  grant_type: string;
  username: string;
  password: string;
}
